<script setup lang="ts">
import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import AppHeader from './components/AppHeader.vue';
import { useAuth } from './composables/useAuth';
import { initHeaderState } from './composables/useHeaderState';
import { usePushNotifications } from './composables/usePushNotifications';

const route = useRoute();
const { user } = useAuth();
const { registerPush } = usePushNotifications();

// Check if current route requires auth (protected routes)
const showHeader = computed(() => {
  return route.meta.requiresAuth === true && route.name !== 'Onboarding';
});

// Determine active page based on route
const activePage = computed(() => {
  if (route.path.startsWith('/services')) return 'services';
  if (route.path.startsWith('/settings')) return 'settings';
  if (route.path.startsWith('/clients')) return 'clients';
  if (route.path.startsWith('/visits')) return 'visits';
  return 'messenger';
});

let pushRegistered = false;

// Initialize header state when user is loaded
watch(
  () => user.value,
  (newUser) => {
    if (newUser) {
      initHeaderState(newUser.id, newUser.organization_id);
      if (!pushRegistered) {
        pushRegistered = true;
        registerPush().catch(() => {});
      }
    }
  },
  { immediate: true },
);
</script>

<template>
  <div class="flex flex-col h-screen overflow-hidden grain-overlay">
    <AppHeader v-if="showHeader" :active-page="activePage" />
    <router-view class="flex-1 overflow-y-auto" />
  </div>
</template>
